import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ProfileSettingsService {
  static getCompanyDetails(companyId) {
    return HttpUtil.get(
      API_ROUTES.PROFILESETTINGS.COMPANYDETAILS.replace(
        "<companyId>",
        companyId
      )
    );
  }
  static updateCompanyDetails(item) {
    return HttpUtil.put(
      API_ROUTES.PROFILESETTINGS.COMPANYDETAILS.replace("<companyId>", item.id),
      item
    );
  }
  static changePassword(param) {
    return HttpUtil.post(API_ROUTES.PROFILESETTINGS.CHANGEPASSWORD, param);
  }
  static updateCompanyLogo(companyId, formData) {
    return HttpUtil.post(
      API_ROUTES.PROFILESETTINGS.UPDATECOMPANYLOGO.replace(
        "<companyId>",
        companyId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  static deleteCompanyLogo(companyId, formData = "") {
    return HttpUtil.delete(
      API_ROUTES.PROFILESETTINGS.DELETECOMPANYLOGO.replace(
        "<companyId>",
        companyId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  static addBranches(companyId,param) {
    return HttpUtil.post(API_ROUTES.PROFILESETTINGS.ADDBRANCH.replace("<companyId>", companyId), param);
  }
  static getBranches(companyId) {
    return HttpUtil.get(API_ROUTES.PROFILESETTINGS.GETBRANCH.replace("<companyId>", companyId));
  }

  static getProfileImg(companyId) {
    return (
      API_ROUTES.PROFILESETTINGS.GETCOMPANYLOGO.replace(
        "<companyId>",
        companyId
      ) +
      "?" +
      new Date().getTime()
    );

  }

  static downloadCompanyLogo(companyId) {
    return HttpUtil.get(API_ROUTES.PROFILESETTINGS.GETCOMPANYLOGO.replace(
      "<companyId>",
      companyId
    ) +
    "?" +
    new Date().getTime());
  }

  static getEsgUtils() {
    return HttpUtil.get(
      API_ROUTES.PROFILESETTINGS.GET_UTILS
    );
  }
}
